// Swiper

const gallerySwiper = () => {
    const gallerySwiper = new Swiper(".gallery-image-side", {
        autoHeight: true,
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            dynamicBullets: true,
            clickable: true,
        },
    });
}


const quoteSwiper = () => {
    const quoteSwiper = new Swiper(".testimonials-quote", {
        autoHeight: true,
        loop: true,
        slidesPerView: 1,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            dynamicBullets: true,
            clickable: true,
        },
    });
}


const carouselSwiper = () => {

    const elements = document.querySelectorAll('.testimonials-carousel');

    elements.forEach((element) => {
        const spaceBetween = element.classList.contains('cards') ? 30 : 100;

        new Swiper(element, {
            slidesPerView: 1,
            spaceBetween: spaceBetween,
            loop: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            pagination: {
                el: ".swiper-pagination",
                dynamicBullets: true,
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 3,
                },
            },
        });
    });
}


const sliderLogosSwiper = () => {

    const elements = document.querySelectorAll('.slider-logos-side');

    elements.forEach((element) => {
        const spaceBetweenMobile = element.classList.contains('cards') ? 10 : 20;
        const spaceBetweenTablet = element.classList.contains('cards') ? 20 : 40;
        const spaceBetweenDesktop = element.classList.contains('cards') ? 30 : 60;

        new Swiper(element, {
            slidesPerView: 2,
            spaceBetween: spaceBetweenMobile,
            loop: true,
            allowTouchMove: false,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            breakpoints: {
                768: {
                    slidesPerView: 4,
                    spaceBetween: spaceBetweenTablet,
                },
                1200: {
                    slidesPerView: 5,
                    spaceBetween: spaceBetweenDesktop,
                },
                1400: {
                    slidesPerView: 6,
                    spaceBetween: spaceBetweenDesktop,
                },
            },
        });
    });
}


const referenceFormSwiper = () => {
    const referenceFormSwiper = new Swiper(".references-logos-side", {
        slidesPerView: 3,
        spaceBetween: 10,
        autoHeight: true,
        loop: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        breakpoints: {
            768: {
                slidesPerView: 6,
                spaceBetween: 20,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 20,
            },
            1400: {
                slidesPerView: 5,
                spaceBetween: 20,
            }
        },
    });
}


const accordionSwiper = (swiperContainer, accordionContainer) => {
    const swiper = new Swiper(swiperContainer, {
        autoHeight: true,
        allowTouchMove: false,
        effect: "fade",
    });

    const accordionButtons = document.querySelectorAll(`${accordionContainer} .accordion-button`);

    accordionButtons.forEach(button => {
        button.addEventListener('click', function() {
            const index = this.getAttribute('data-swiper-slide-index');
            swiper.slideTo(index);
        });
    });
};

document.addEventListener('DOMContentLoaded', function() {
    const swipers = document.querySelectorAll('.accordion-image-side.swiper');

    swipers.forEach((swiperElement) => {
        const synchId = swiperElement.getAttribute('data-synch');
        const accordionContainer = `[data-synch='${synchId}']`; // Sélectionne l'accordéon lié par data-synch
        accordionSwiper(swiperElement, accordionContainer);
    });
});




const heroSwiper = () => {
    const heroSwiper = new Swiper(".hero-image-side", {
        autoHeight: false,
        slidesPerView: 1,
        loop: true,
        effect: "fade",
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            dynamicBullets: true,
            clickable: true,
        },
    });
}


const notificationSwiper = () => {
    const notificationSwiper = new Swiper(".notification-header", {
        autoHeight: true,
        slidesPerView: 1,
        loop: true,
        effect: "fade",
        autoplay: {
            delay: 6000,
            disableOnInteraction: false,
        }
    });
}



// Call functions

gallerySwiper();
quoteSwiper();
carouselSwiper();
sliderLogosSwiper();
referenceFormSwiper();
heroSwiper();
notificationSwiper();



document.addEventListener("DOMContentLoaded", function() {

    var landingWrapper = document.getElementById('landing-wrapper');

    // Vérifier si l'élément #landing-wrapper existe
    if (!landingWrapper) {
        return; // Stoppe l'exécution si l'élément n'existe pas
    }

    var firstChild = landingWrapper.firstElementChild;
    if (firstChild && firstChild.tagName.toLowerCase() === 'section') {
        var classes = firstChild.className.split(' ');
        var hasBkgClass = classes.some(function(cls) {
            return cls.startsWith('bkg-');
        });
        if (hasBkgClass) {
            landingWrapper.classList.add('no-padding');
        }
    }

});



document.addEventListener('DOMContentLoaded', function () {

    // Vérifier si l'élément section.frise existe
    const friseSection = document.querySelector('section.frise');
    if (!friseSection) {
        return; // Stoppe l'exécution si section.frise n'existe pas
    }

    const timelineContainer = document.querySelector('.timeline-container');
    const timelineItems = document.querySelectorAll('.timeline-item');
    const filledBar = document.createElement('div');
    filledBar.classList.add('filled-bar');
    timelineContainer.appendChild(filledBar);

    const updateFilledBarHeight = () => {
        const scrollTop = window.scrollY;
        const timelineContainerTop = timelineContainer.offsetTop;
        const timelineContainerHeight = timelineContainer.offsetHeight;
        const windowHeight = window.innerHeight;
        const maxScroll = timelineContainerHeight - windowHeight;
        
        let scrollPercent = (scrollTop - timelineContainerTop + (windowHeight / 2)) / timelineContainerHeight;
        scrollPercent = Math.min(Math.max(scrollPercent, 0), 1);
        
        const filledHeight = scrollPercent * timelineContainerHeight;
        filledBar.style.height = `${filledHeight}px`;
    };

    const adjustContentAlignment = () => {
        timelineItems.forEach(item => {
            const dateContent = item.querySelector('.timeline-date .content-text');
            const content = item.querySelector('.timeline-content .content-text');
            
            if (dateContent.querySelector('h3')) {
                const titleHeight = dateContent.querySelector('h3').offsetHeight;
                const titleMarginBottom = parseInt(window.getComputedStyle(dateContent.querySelector('h3')).marginBottom, 10);
                content.style.marginTop = `${titleHeight + titleMarginBottom}px`;
            } else {
                content.style.marginTop = '0';
            }
        });
    };

    window.addEventListener('scroll', updateFilledBarHeight);
    window.addEventListener('resize', adjustContentAlignment);

    updateFilledBarHeight();
    adjustContentAlignment(); // Initial call
    
});



document.addEventListener('DOMContentLoaded', function() {
    const navbar = document.querySelector('#wrapper-navbar.scrolling');
    const footer = document.getElementById('wrapper-footer');
    const stickyOffset = 400;

    window.addEventListener('scroll', function() {
        const footerOffset = footer.offsetTop + 800;
        const footerHeight = footer.offsetHeight;

        if (window.scrollY > stickyOffset && window.scrollY < (footerOffset - footerHeight - navbar.offsetHeight)) {
            navbar.classList.add('show');
        } else {
            navbar.classList.remove('show');
        }
    });
});
